// ── Auto-match estricto de documentos contra prerrequisitos faltantes ───────────
// Para el recuadro "Documentos Belray": si la persona YA tiene un documento que
// calza un prerrequisito faltante, lo damos por cubierto automáticamente.
// Criterio ESTRICTO (poco falso positivo):
//   - tipo_normalizado idéntico, o
//   - nombre/tipo normalizado idéntico.
// Los documentos VENCIDOS no cuentan (se dejan pendientes de renovar).

export const normMatch = (s?: string): string =>
  String(s || '')
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const esVencido = (d: any): boolean => d?.vencido === true || d?.vencido === 'true';

// Busca en `disponibles` un documento que cubra estrictamente el `faltante`,
// ignorando ids ya usados por otro match y los vencidos.
export const findStrictCandidato = (faltante: any, disponibles: any[], yaUsados: Set<string>): any | null => {
  const pTipo = normMatch(faltante?.tipo_normalizado || faltante?.tipo_documento || faltante?.tipo || '');
  const pNombre = normMatch(faltante?.label || faltante?.nombre || faltante?.value || faltante?.tipo_documento || '');
  if (!pTipo && !pNombre) return null;
  return (
    (disponibles || []).find((d: any) => {
      if (!d || yaUsados.has(String(d.id))) return false;
      if (esVencido(d)) return false;
      const dKey = normMatch(d.tipo_key || d.tipo_normalizado || '');
      const dOrig = normMatch(d.tipo_original || d.tipo_documento || '');
      if (pTipo && dKey && dKey === pTipo) return true;            // tipo_normalizado exacto
      if (pNombre && (dOrig === pNombre || dKey === pNombre)) return true; // nombre idéntico
      return false;
    }) ?? null
  );
};

export interface AutoMatchBelray {
  prereqId: any;
  faltante: any;
  candidato: any;
}

// Recorre los faltantes y devuelve los matches estrictos encontrados.
// Un documento solo se usa para UN prerrequisito (no se reutiliza).
export const computeAutoMatchesBelray = (faltantes: any[], disponibles: any[]): AutoMatchBelray[] => {
  const usados = new Set<string>();
  const out: AutoMatchBelray[] = [];
  for (const f of faltantes || []) {
    const cand = findStrictCandidato(f, disponibles || [], usados);
    if (cand) {
      usados.add(String(cand.id));
      out.push({ prereqId: f?.prerequisito_id ?? f?.id ?? null, faltante: f, candidato: cand });
    }
  }
  return out;
};
